module.exports = __webpack_public_path__ + "img/fondo2.9dc66941.png";